import { cn } from '@/lib/utils'

interface ScoreBadgeProps {
  score: number | null | undefined
  className?: string
}

export function ScoreBadge({ score, className }: ScoreBadgeProps) {
  if (score === null || score === undefined) {
    return (
      <span className={cn('text-muted-foreground text-sm', className)}>
        N/A
      </span>
    )
  }

  const getScoreColor = (score: number) => {
    if (score >= 80) return 'bg-success text-success-foreground'
    if (score >= 60) return 'bg-info text-info-foreground'
    if (score >= 40) return 'bg-warning text-warning-foreground'
    return 'bg-muted text-muted-foreground'
  }

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full px-2 py-0.5 text-xs font-semibold',
        getScoreColor(score),
        className
      )}
    >
      {score}
    </span>
  )
}
